export class DefinisciFascicoloRequest {
  dataDefinizione: number;
  idFascicolo: string;
  idPratica: string;
  idMotivoDefinizione: string;
}

